<template>
    <div class="videos">
        <video-player
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
            @ended="onPlayerEnded($event)"
        ></video-player>
    </div>
</template>
  
  <script>
// import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'
import { Toast } from 'vant';

export default {
    name: 'Videos',
    //子组件接收父组件(VideoList)
    props: ['videoList', 'index', 'cur_index', "isIOS"],
    data() {
        const t_width = document.documentElement.clientWidth > 750 ? 750 : document.documentElement.clientWidth


        return {
            playerOptions: {
                autoplay: false, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: 'meta',
                //fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [
                    {
                        src: this.videoList.url,  // 路径
                        type: 'video/mp4'  // 类型
                    },
                ],
                width: t_width,
                height: document.documentElement.clientHeight,
                notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: false,
                aspectRatio: `${t_width}:${document.documentElement.clientHeight}`
            },
            playing: true,
            init_count: 0,
            first_flag: false
        }
    },
    created() {
        this.autoPlayAction();
        console.log(this.videoList);
    },
    methods: {
        async playOrStop() {

            console.log(this.$refs.videoPlayer.player.hasStarted())
            if (!this.first_flag && !this.$refs.videoPlayer.player.hasStarted()) {
                this.playing = true;
                this.first_flag = true;
            } else {
                if (this.playing) {
                    await this.$refs.videoPlayer.player.pause();
                    this.playing = false;
                } else {
                    await this.$refs.videoPlayer.player.play();
                    this.playing = true;
                }
            }
        },
        //自动播放第一个视频
        autoPlayAction() {
            if (this.index == 0) {
                this.playerOptions.preload = "auto";
            }

            if (this.index == 0 && !this.isIOS) {
                this.playerOptions.autoplay = true;
            }
            if (this.videoList.poster) {
                this.playerOptions.poster = this.videoList.poster
            }

            this.playing = !this.isIOS;
        },
        onPlayerEnded() {
            console.log("执行我啦！")
            if (this.init_count == 0) {
                Toast('播放完毕，上滑查看更多推荐视频')
                this.init_count++
            }

            if (!this.isIOS) {
                // 一秒后重新播放
                setTimeout(() => {
                    // 如果焦点还在的话
                    if (this.cur_index == this.index) {
                        this.play();
                    }
                }, 1500);
            }

        },
        async play() {
            //重新载入
            this.$refs.videoPlayer.player.load();
            await this.$refs.videoPlayer.player.play();
            this.playing = true;
        },
        async stop() {
            await this.$refs.videoPlayer.player.pause();
            this.playing = false;
        }
    },
    components: {
        videoPlayer
    }
}
</script>
  
  <style>
.fullscreen_button {
    width: 100px;
    height: 100px;
    position: absolute;
    background-color: blue;
    top: 0;
}
.videos {
    position: relative;
    height: 100%;
}
.videos .vjs-custom-skin > .video-js .vjs-big-play-button {
    background: rgba(0, 0, 0, 0.4);
    font-size: 30px;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>